import {Nullable} from "@/general/custom-types/CustomTypes";

export class UploadFormModel {
  identifier?: Nullable<string>;
  file?: Nullable<string>;

  constructor(
    identifier?: Nullable<string>,
    file?: Nullable<string>,
  ) {
    this.identifier = identifier;
    this.file = file;
  }
}
